// Plain value checks, kept apart from utility.js so the page components can use them
// without pulling in the legacy element graph that utility.js imports.

function isWholeNumber(value) {
  if (value === "") {
    return false;
  }

  return Number.isInteger(Number(value));
}

function isDecimalNumber(value) {
  if (value === "") {
    return false;
  }

  return (
    !Number.isNaN(Number(value)) &&
    value.includes(".") &&
    !value.endsWith(".")
  );
}

function isMonthDayValue(value, months) {
  const parts = value.split("-");
  if (parts.length !== 2) {
    return false;
  }

  const [month, day] = parts;
  if (!months.includes(month) || day.length !== 2) {
    return false;
  }

  const dayNumber = Number(day);
  return (
    Number.isInteger(dayNumber) && dayNumber >= 1 && dayNumber <= 31
  );
}

export { isDecimalNumber, isMonthDayValue, isWholeNumber };
